import React from 'react';
import { useTranslation } from 'react-i18next';

function FriendRequest({ img, name, count }) {
  const { t } = useTranslation();
  return (
    <div className="iq-friend-request">
      <div className="iq-sub-card iq-sub-card-big d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <div className="">
            <img className="avatar-40 rounded" src={img} alt={name} />
          </div>
          <div className="media-body ms-3">
            <h6 className="mb-0 ">{name}</h6>
            <p className="mb-0">
              {count} {t("teman")}
            </p>
          </div>
        </div>
        <div className="d-flex align-items-center">
          <button className="me-3 btn btn-primary rounded">
            {t("konfirmasi")}
          </button>
          <button className="me-3 btn btn-secondary rounded">
            {t("hapus_permintaan")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default FriendRequest;
